const PREFIX = 'ijch_'
const listeners = {}

export const storage = {
  get (key) {
    try {
      return JSON.parse(localStorage.getItem(PREFIX + key))
    } catch {
      return null
    }
  },
  set (key, value) {
    localStorage.setItem(PREFIX + key, JSON.stringify(value))
    const fns = listeners[key] || []
    fns.forEach(fn => fn(value))
  },
  on (key, fn) {
    if (!listeners[key]) listeners[key] = []
    listeners[key].push(fn)
  },
  off (key, fn) {
    if (listeners[key]) {
      listeners[key] = listeners[key].filter(f => f !== fn)
    }
  }
}
